module.exports = __webpack_public_path__ + "img/zhongjianshang.fa0ce3b4.png";